var React = require('react');

function Alert (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.50031 1.13292C9.65686 1.22228 9.78658 1.35193 9.87599 1.50839L17.867 15.4917C18.1433 15.9752 17.9751 16.5911 17.4913 16.8673C17.3389 16.9542 17.1665 17 16.991 17H1.00884C0.451673 17 0 16.5486 0 15.9917C0 15.8163 0.0457802 15.644 0.132819 15.4917L8.12395 1.50838C8.40028 1.02484 9.0165 0.856739 9.50031 1.13292ZM8.99999 12.75C8.30963 12.75 7.74999 13.3096 7.74999 14C7.74999 14.6904 8.30963 15.25 8.99999 15.25C9.69034 15.25 10.25 14.6904 10.25 14C10.25 13.3096 9.69034 12.75 8.99999 12.75ZM7.99999 6H9.99999V11H7.99999V6Z","fill":"currentColor"}));
}

Alert.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Alert;

Alert.default = Alert;
